import * as prismic from '@prismicio/client';
export var repositoryName = 'new-airdao-website';
export var client = prismic.createClient(repositoryName);
//# sourceMappingURL=prismic.js.map